import { Typography, Box } from "@mui/material";
import { Trans } from "@lingui/macro";
import Image from "next/image";
import price from "@/utils/price";
import React from "react";

interface ProductObj {
  id: number;
  name: string;
  price: number;
  price_formated: string;
  image: string;
  stock_status_id: number;
  offerz_show_gift_button: boolean;
  special: number;
}

interface ProductInfoProps {
  product: ProductObj;
}

const ProductInfo = ({ product }: ProductInfoProps) => {
  return (
    <Box data-testid="product-info-section">
      {product.price !== 0 &&
        (product.special === 0 ? (
          <Typography
            sx={{
              fontSize: { xs: "20px", md: "30px" },
              fontWeight: 800,
              mb: 0,
            }}
          >
            {product.price_formated}
          </Typography>
        ) : (
          <Typography
            variant="h5"
            sx={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "flex-start",
              flexDirection: "row",
              mb: { xs: "8px", md: "0" },
              gap: "4px",
              color: "#ff3030",
              fontSize: { xs: "20px", md: "30px" },
            }}
          >
            {price(product.special)}
            <Typography
              variant="body1"
              sx={{
                textDecoration: "line-through",
                color: "#ff3030",
                fontSize: "15px",
              }}
            >
              {price(product.price)}
            </Typography>
          </Typography>
        ))}
      <Typography
        sx={{
          fontSize: { xs: "20px", md: "30px" },
          fontWeight: 500,
          mb: "14px",
          lineHeight: "normal",
        }}
      >
        {product.name}
      </Typography>

      {product.stock_status_id === 7 && (
        <Typography variant="h6" sx={{ display: "inline-flex", color: "#404647" }}>
          <Trans>
            Delivery
            <Image
              priority
              className="ml-2 mr-1"
              src="/lightning-icon.svg"
              alt="icon"
              width={15}
              height={15}
            />
            <Box component="span" className="mr-2 font-semibold text-[#00b54f]">
              INSTANT
            </Box>
            for Download
          </Trans>
        </Typography>
      )}
    </Box>
  );
};

export default React.memo(ProductInfo);
